import {dataset, findMany, on, jsonParse} from '../helpers';

export const GaEvent = ({name, category, action, event, label}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event || 'CraftEvent',
        eventCategory: category || 'Generic Event',
        eventAction: action || 'Unknown',
        eventLabel: name || label || null,
    });
};

export const formEvent = ({name, category, action, event}) => {
    return GaEvent({name, action, event, category: category || 'Forms'});
};

export const listenForClickEvents = () => {
    findMany('[data-event]').forEach((button) => {
        if (button.listeningForClicks) {
            return false;
        }

        const config = jsonParse(dataset(button, 'event'));

        const event = {
            category: 'Clicks',
            ...(typeof config === 'object' ? config : {name: config}),
        };

        let watchingForDoubleClick;

        on(
            'click',
            () => {
                if (!watchingForDoubleClick) {
                    watchingForDoubleClick = setTimeout(() => {
                        GaEvent({action: 'Single Click', ...event});
                        watchingForDoubleClick = null;
                    }, 500);
                }
            },
            button,
        );

        on(
            'dblclick',
            () => {
                GaEvent({...event, action: 'Double Click'});
                clearTimeout(watchingForDoubleClick);
                watchingForDoubleClick = null;
            },
            button,
        );

        on(
            'contextmenu',
            () => {
                GaEvent({...event, action: 'Right Click'});
            },
            button,
        );

        button.listeningForClicks = true;
    });
};

listenForClickEvents();

setTimeout(() => {
    listenForClickEvents();
}, 2000);
